import {
  Button,
  CloseButton,
  Flex,
  Heading,
  IconTableTopHeaderLine,
  Modal,
  NumberInput,
} from "@instructure/ui";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { INSERT_TABLE_COMMAND } from "@lexical/table";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const TablePlugin = ({ disabled = false }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [editor] = useLexicalComposerContext();
  const [numRows, setNumRows] = useState(5);
  const [numCols, setNumCols] = useState(5);

  function handleInsert(numRows, numCols) {
    editor.focus();
    editor.dispatchCommand(INSERT_TABLE_COMMAND, {
      rows: numRows,
      columns: numCols,
    });
    setOpen(false);
  }

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="toolbar-item spaced"
        aria-label={t("rte.table.insertTable")}
        title={t("rte.table.insertTable")}
        disabled={disabled}
      >
        <IconTableTopHeaderLine size="x-small" />
      </button>
      <Modal
        open={open}
        label={t("rte.table.insertTable")}
        onExited={() => {
          setNumRows(5);
          setNumCols(5);
        }}
      >
        <Modal.Header>
          <Flex justifyItems="space-between">
            <Flex.Item>
              <Heading as="h3">{t("rte.table.insertTable")}</Heading>
            </Flex.Item>
            <Flex.Item>
              <CloseButton
                offset="small"
                onClick={() => setOpen(false)}
                screenReaderLabel={t("global.close")}
              />
            </Flex.Item>
          </Flex>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
          >
            <NumberInput
              renderLabel={t("rte.table.rows")}
              value={numRows}
              onIncrement={() =>
                setNumRows((prev) => (prev === 500 ? prev : Number(prev) + 1))
              }
              onDecrement={() =>
                setNumRows((prev) => (prev > 1 ? prev - 1 : prev))
              }
              onChange={(_, value) => {
                value = value ? Number(value) : "";
                if (!Number.isNaN(value)) {
                  if (value > 500) {
                    setNumRows(500);
                  } else {
                    setNumRows(value);
                  }
                }
              }}
              placeholder={t("rte.table.rowsPlaceholder")}
            />
            <NumberInput
              renderLabel={t("rte.table.columns")}
              value={numCols}
              onIncrement={() =>
                setNumCols((prev) => (prev === 50 ? prev : Number(prev) + 1))
              }
              onDecrement={() =>
                setNumCols((prev) => (prev > 1 ? prev - 1 : prev))
              }
              onChange={(_, value) => {
                value = value ? Number(value) : "";
                if (!Number.isNaN(value)) {
                  if (value > 50) {
                    setNumCols(50);
                  } else {
                    setNumCols(value);
                  }
                }
              }}
              placeholder={t("rte.table.columnsPlaceholder")}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="primary"
            onClick={() => handleInsert(numRows, numCols)}
            disabled={numRows < 1 || numCols < 1}
          >
            {t("global.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
